import React, {FC} from 'react';
import useTranslate from "../../core/languages/hooks/useTranslate";
import {TransferStatusEnum} from "../../transfers/enums/TransferStatusEnum";
import {Alert} from "../../ui/shared/Alert/Alert";
import Transfer from "../../transfers/types/Transfer";

interface AlertStatusSectionProps {
  transferInfo?: Transfer;
  hasSidebar?: boolean;
}

const AlertStatusSection: FC<AlertStatusSectionProps> = ({transferInfo, hasSidebar}) => {
  const t = useTranslate();

  return (
    <>
      {/* Status Alerts */}
      {transferInfo?.status === TransferStatusEnum.CONFIRMED ? (
        <Alert type="success" closable={false} containerClassName="mb-5 w-full py-2 px-3">
          <p className="text-sm">{transferInfo.paymentStatus === 'paid' ?
            t("transferOk.message.transferConfirmedAndPaid") : t("transferOk.message.transferConfirmed")}
          </p>
        </Alert>
      ) : transferInfo?.status === TransferStatusEnum.CANCELLED ? (
        <Alert type="error" closable={false} containerClassName="mb-5 w-full py-2 px-3">
          <p className="text-sm">{transferInfo.paymentStatus === 'refunded' ?
            t("transferOk.message.transferCanceledAndRefunded") : t("transferOk.message.transferCanceled")}
          </p>
        </Alert>
      ) : transferInfo?.status === TransferStatusEnum.TRANSFER_CREATED ? (
        <Alert type="warning" closable={false} containerClassName="mb-5 w-full py-2 px-3">
          <p className="text-sm">{hasSidebar ?
            t("transferOk.message.transferPaymentRequested") : t("transferOk.message.transferPending")}
          </p>
        </Alert>
      ) : (
        <Alert type="warning" closable={false} containerClassName="mb-5 w-full py-2 px-3">
          <p className="text-sm">{t("transferOk.message.transferPending")}</p>
        </Alert>
      )}
    </>
  );
};

export default AlertStatusSection;

